import React from 'react'
import {Form, Result, Select, Space, Typography} from "antd"
import {useClubTableBookSettingContext} from "../store/useClubTableBookSettingContext"
import moment from "moment/moment"

const BookSettingLock = () => {
    const lockDuration = []
    for (let i = 1; i <= 8; i++) {
        const duration = i * 30
        lockDuration.push({
            label: `${duration}分钟`,
            value: moment.duration(duration, 'minutes').toISOString()
        })
    }


    const {form, isShowReserve} = useClubTableBookSettingContext()

    return (
        <div>
            {isShowReserve ? <Form
                form={form}
                initialValues={{
                    lockDuration: "PT30M"
                }}
            >
                <Form.Item
                    label={"散客开台后"}
                >
                    <Space>
                        <Form.Item name={"lockDuration"} noStyle>
                            <Select style={{width: 200}}
                                    options={lockDuration} placeholder={"请输入锁定时长"}

                            ></Select>
                        </Form.Item>
                        <Typography.Text>内不可预订</Typography.Text>
                    </Space>
                </Form.Item>
            </Form> : <Result status={"info"} subTitle={"暂未开启预定，开启可以编写"}></Result>}
        </div>
    )
}

export default BookSettingLock


// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/bookSettings/component/BookSettingLock.js